import { DEFAULT_MARKETING_THEME, isMarketingThemeId, MarketingThemeId } from './marketingThemes';

const rawEnvironment = (process.env.REACT_APP_ENVIRONMENT || 'development').trim().toLowerCase();
const rawTheme = (process.env.REACT_APP_MARKETING_THEME || '').trim();

export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    version: process.env.REACT_APP_API_VERSION,
  },
  auth: {
    domain: process.env.REACT_APP_AUTH_DOMAIN,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
  },
  features: {
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableComments: process.env.REACT_APP_ENABLE_COMMENTS === 'true',
  },
  app: {
    name: process.env.REACT_APP_APP_NAME,
    /** Defaults to `development` when unset. `production` hides the marketing theme picker. */
    environment: rawEnvironment || 'development',
    /** Defaults to `signal-teal` when unset or invalid. */
    marketingTheme: (isMarketingThemeId(rawTheme) ? rawTheme : DEFAULT_MARKETING_THEME) as MarketingThemeId,
  },
};

/** True only when REACT_APP_ENVIRONMENT is `production`. */
export const isProductionEnvironment = config.app.environment === 'production';

/** Theme picker is available when not production. */
export const isMarketingThemePickerEnabled = !isProductionEnvironment;
